import { useContext, useEffect } from "react";
import { useUnifiedService } from "../contexts/UnifiedServiceContext";
import { ServiceStatus } from "../types/unified-services";
import SdkContext from "../contexts/sdk/sdkContext";
import SdkApi from "../Api/sdk/Api";

export const useSdkResultsHandler = () => {
  const { serviceInterface, serviceConfig, bodyMeasurement, autoTagging, visualSearch } = useUnifiedService();
  const { status } = serviceInterface;
  const sdkContext = useContext(SdkContext);

  useEffect(() => {
    if (status === ServiceStatus.SUCCESS && sdkContext.callback) {
      handleResultsCallback();
    }
  }, [status, sdkContext.callback]);

  const handleResultsCallback = async () => {
    try {
      let resultData: any = null;

      switch (serviceConfig.serviceId) {
        case "body-measurement":
          resultData = bodyMeasurement.measurementData;
          break;
        case "auto-tagging":
          resultData = autoTagging.result;
          break;
        case "visual-search":
          resultData = visualSearch.recognizedClothing;
          break;
        case "garment-measurement":
          break;
        default:
          return;
      }

      if (resultData && sdkContext.callback) {
        await SdkApi.post(sdkContext.callback, resultData);
      }
    } catch (error) {}
  };

  return {
    handleResultsCallback,
  };
};

export const SdkResultsHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useSdkResultsHandler();
  return <>{children}</>;
};
